import React, { useEffect, useState } from "react";
import { Container, Row, Col, Card, Spinner } from "react-bootstrap";
import heroBg from "../assets/images/HeroBanner.png";
import { useNavigate } from "react-router-dom";
import "../styles/ContactUs.css";

const ContactUs = () => {
  const navigate = useNavigate();
  const [tokenState, setTokenState] = useState(localStorage.getItem("token"));
  const [contacts, setContacts] = useState([]);
  const [videos, setVideos] = useState([]); // ⬅ NEW: store help videos
  const [loading, setLoading] = useState(true);
  const [videoLoading, setVideoLoading] = useState(true); // ⬅ NEW

  const handleMemberLogin = () => navigate("/member-login");
  const handleEdcclogin = () => navigate("/edcc-login");

  // Watch localStorage token changes
  useEffect(() => {
    const interval = setInterval(() => {
      const currentToken = localStorage.getItem("token");
      if (currentToken !== tokenState) setTokenState(currentToken);
    }, 500);
    return () => clearInterval(interval);
  }, [tokenState]);

  // Fetch contact cards
  useEffect(() => {
    const fetchContacts = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_BASEURL}/getAllcontactcms`
        );
        const result = await response.json();
        if (result.success) setContacts(result.data);
      } catch (error) {
        console.error("Error fetching contacts:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchContacts();
  }, []);

  // Fetch Help & Support videos
  useEffect(() => {
    const fetchVideos = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_BASEURL}/get-all-help-videos`
        );
        const data = await response.json();

        if (data.success) {
          // Convert normal YouTube URL → embed format
          const formatted = data.data.map((video) => {
            let url = video.video_url.trim();

            // Convert normal YouTube URLs
            if (url.includes("watch?v=")) {
              const videoId = url.split("watch?v=")[1].split("&")[0];
              url = `https://www.youtube.com/embed/${videoId}`;
            }

            // Convert share URLs (youtu.be)
            if (url.includes("youtu.be/")) {
              const videoId = url.split("youtu.be/")[1].split("?")[0];
              url = `https://www.youtube.com/embed/${videoId}`;
            }

            return {
              ...video,
              embedUrl: url,
            };
          });

          setVideos(formatted);
        }
      } catch (error) {
        console.error("Video Fetch Error:", error);
      } finally {
        setVideoLoading(false);
      }
    };

    fetchVideos();
  }, []);

  return (
    <>
      {/* Hero Section */}
      <section
        className="hero-fixed"
        style={{ backgroundImage: `url(${heroBg})` }}
      >
        <div className="hero-scroll-content">
          <div className="hero-content-home poppins-regular">
            <h1 className="hero-heading">
              All India Occupational Therapists' Association
            </h1>

            {!tokenState && (
              <div className="hero-buttons">
                <button className="glass-button" onClick={handleMemberLogin}>
                  Member Login
                </button>
                <button className="glass-button" onClick={handleEdcclogin}>
                  Ergonomic Certificate login
                </button>
              </div>
            )}
          </div>
        </div>
      </section>

      {/* Scrollable Content */}
      <div className="scrollable-content-home">
        <div className="content-container contact-us-content-container">
          <section className="contact-us-section">
            <Container className="mt-5">
              <h2 className="text-center contact-us-heading mb-3">
                Contact Us
              </h2>

              {/* Google Map */}
              <div className="map-section">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d60346.176817869135!2d72.97736967204041!3d19.035752565416452!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7c3dc2003fadd%3A0x689fa99dd927e1d5!2sALL%20INDIA%20OCCUPATIONAL%20THERAPISTS%20ASSOCIATION%20(AIOTA)!5e0!3m2!1sen!2sin!4v1757476110936!5m2!1sen!2sin"
                  width="100%"
                  height="450"
                  style={{ border: 0, borderRadius: "20px" }}
                  loading="lazy"
                ></iframe>
              </div>

              {/* Contact Cards */}
              {loading ? (
                <div className="text-center my-5">
                  <Spinner animation="border" variant="light" />
                </div>
              ) : (
                <Row className="g-5 mb-4 mt-5 d-flex justify-content-center">
                  {contacts.map((contact, index) => (
                    <Col xs={12} md={5} key={index}>
                      <Card className="h-100 text-center text-light contact-us-card">
                        <Card.Body>
                          <Card.Title className="contact-us-card-title poppins-medium">
                            {contact.position}
                          </Card.Title>

                          {contact.designation && (
                            <Card.Subtitle className="mb-2">
                              {contact.designation}
                            </Card.Subtitle>
                          )}

                          <Card.Subtitle className="mb-3">
                            {contact.name}
                          </Card.Subtitle>
                          <Card.Text>
                            <strong>Address:</strong> {contact.address}
                          </Card.Text>
                          {contact.mobile && (
                            <Card.Text>
                              <strong>Mobile:</strong> {contact.mobile}
                            </Card.Text>
                          )}
                          {contact.telephone && (
                            <Card.Text>
                              <strong>Telephone:</strong> {contact.telephone}
                            </Card.Text>
                          )}
                          {contact.email && (
                            <Card.Text>
                              <strong>Email:</strong> {contact.email}
                            </Card.Text>
                          )}
                        </Card.Body>
                      </Card>
                    </Col>
                  ))}
                </Row>
              )}

              {/* Help Videos Section */}
              <section className="contact-us-tutorial-section">
                <h2 className="text-center mb-4 mt-5">Help & Support</h2>

                {videoLoading ? (
                  <div className="text-center my-5">
                    <Spinner animation="border" variant="light" />
                  </div>
                ) : videos.length === 0 ? (
                  <p className="text-center text-light">
                    No help videos available.
                  </p>
                ) : (
                  <Row className="justify-content-center">
                    {videos.map((video) => (
                      <Col
                        key={video._id}
                        xs={12}
                        md={6}
                        lg={4}
                        className="mb-4"
                      >
                        <div className="contact-us-tutorial-card">
                          <iframe
                            src={video.embedUrl}
                            title={video.title}
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                          ></iframe>
                          <p>{video.title}</p>
                        </div>
                      </Col>
                    ))}
                  </Row>
                )}
              </section>
            </Container>
          </section>
        </div>
      </div>
    </>
  );
};

export default ContactUs;
